import Vue from 'vue'

import d2Container from './d2-container'
import d2Icon from './d2-icon'
import d2PageCover from './d2-page-cover'
import d2IconSvg from './d2-icon-svg'
import d2ConfirmControl from './d2-confirm-control'
import d2SwitchControl from './d2-switch-control'
import d2PopoverControl from './d2-popover-control'
import d2Pagination from './d2-pagination'
import d2Upload from './d2-upload'
import d2Textarea from './d2-textarea'
import d2Uedit from './d2-uedit'
import d2Daterange from './d2-daterange'
import d2Datetime from './d2-datetime'
import d2Datetype from './d2-datetype'
import d2Date from './d2-date'
import d2Minute from './d2-minute'
import d2Map from './d2-map'
import d2Tabs from './d2-tabs'
import d2TableColumn from './d2-table-column/index.vue'
import d2InputPrice from './d2-input-price/index.vue'
import d2Address from './d2-address/index.vue'

// 注意 有些组件使用异步加载会有影响
Vue.component('d2-container', d2Container)
Vue.component('d2-page-cover', d2PageCover)
Vue.component('d2-icon', d2Icon)
Vue.component('d2-icon-svg', d2IconSvg)
Vue.component('d2-confirm-control', d2ConfirmControl)
Vue.component('d2-switch-control', d2SwitchControl)
Vue.component('d2-popover-control', d2PopoverControl)
Vue.component('d2-pagination', d2Pagination)
Vue.component('d2-upload', d2Upload)
Vue.component('d2-textarea', d2Textarea)
Vue.component('d2-uedit', d2Uedit)
Vue.component('d2-daterange', d2Daterange)
Vue.component('d2-map', d2Map)
Vue.component('d2-tabs', d2Tabs)
Vue.component('d2-datetime', d2Datetime)
Vue.component('d2-date', d2Date)
Vue.component('d2-datetype', d2Datetype)
Vue.component('d2-minute', d2Minute)
Vue.component('d2-table-column', d2TableColumn)
Vue.component('d2-input-price', d2InputPrice)
Vue.component('d2-address', d2Address)
